import React from 'react';
import { motion } from 'framer-motion';
import { Lock, ShieldCheck, Zap } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
export function PricingSection() {
  const handleCheckoutClick = () => {
    trackAddToCart();
  };
  return <section id="comprar" className="py-24 px-4 relative overflow-hidden" data-id="element-122">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-blue-900/15 rounded-full blur-[150px] -z-10 pointer-events-none" data-id="element-123"></div>

      <div className="max-w-5xl mx-auto" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-125">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-126">
            ACCESO INMEDIATO
          </h2>
          <p className="text-xl text-slate-400" data-id="element-127">
            Obtén el "Protocolo 7 Minutos" hoy.
          </p>
        </motion.div>

        <div className="max-w-md mx-auto bg-slate-900 border border-slate-700 rounded-3xl shadow-2xl overflow-hidden relative" data-id="element-128">
          {/* Highlight top bar */}
          <div className="h-2 w-full bg-gradient-to-r from-blue-600 via-blue-400 to-blue-600" data-id="element-129"></div>

          <div className="p-8 flex flex-col items-center" data-id="element-130">
            <img src="https://cdn.magicpatterns.com/uploads/4XJAxL1LqPZmUoF4ryzigx/Diseno_sin_titulo.png" alt="Protocolo 7 Minutos" className="w-48 h-auto rounded-lg shadow-lg mb-8 border border-slate-800" data-id="element-131" />

            <div className="text-center mb-8 w-full" data-id="element-132">
              <div className="flex justify-center items-center gap-3 mb-2" data-id="element-133">
                <span className="text-slate-500 text-xl line-through decoration-red-500/50 decoration-2" data-id="element-134">
                  $35.99 USD
                </span>
                <span className="bg-emerald-500/20 text-emerald-400 text-sm font-bold px-3 py-1 rounded-full border border-emerald-500/30" data-id="element-135">
                  🔥 Ahorras $29.00 USD
                </span>
              </div>
              <div className="text-6xl font-extrabold text-amber-500 drop-shadow-[0_0_15px_rgba(245,158,11,0.3)] mb-2" data-id="element-136">
                $6.99 <span className="text-3xl" data-id="element-137">USD</span>
              </div>
              <p className="text-slate-400 font-medium" data-id="element-138">
                Un pago único para una solución de por vida.
              </p>
            </div>

            <a href="https://pay.hotmart.com/N106214049R" onClick={handleCheckoutClick} className="w-full flex justify-center items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white font-bold text-xl py-5 px-6 rounded-2xl transition-all duration-300 shadow-[0_0_25px_rgba(37,99,235,0.5)] hover:shadow-[0_0_40px_rgba(37,99,235,0.7)] hover:scale-105 active:scale-95 mb-6" data-id="element-139">
              <Zap className="w-6 h-6" data-id="element-140" />
              DESCARGAR PROTOCOLO AHORA
            </a>

            <div className="flex flex-col items-center gap-3 text-sm text-slate-400 w-full" data-id="element-141">
              <div className="flex items-center gap-2" data-id="element-142">
                <Lock className="w-4 h-4 text-emerald-500" data-id="element-143" />
                <span data-id="element-144">Pago 100% seguro.</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-145">
                <ShieldCheck className="w-4 h-4 text-blue-500" data-id="element-146" />
                <span data-id="element-147">Acceso instantáneo incluso si son las 2:00 AM.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}